module.exports = __webpack_public_path__ + "img/violet_126.64a14bd9.png";